import {
    LOAD_TASK_BY_ID,
    GET_TASK_BY_ID,
    GET_PAINT_LIST,
    GET_DYNAMIC_FIELDS,
    GET_PROJECT_LIST,
    GET_HTML_PRE_VIEW,
    GET_COMMENTS_LIST,
    GET_SALES_PERSONS_LIST,
    ADD_COMMENT,
    GET_HISTORY_POSITION,
    GET_HISTORY_STATUS,
    GET_HISTORY_CREATED,
    GET_HISTORY_UPDATE,
    GET_HISTORY_VIEW,
    SET_PROJECT_ATTACHMENTS,
    DELETE_TASK_BY_ID,
    DELETE_ATTACHMENT,
    SEND_SUPPLIER_EMAIL,
} from '../../actions/tasks';

function _addComment(state, payload) {
    if (state && state.comments && state.comments.length > 0) {
        state.comments.push(payload);
    }
}

export default function tasks(state = {}, action) {
    switch (action.type) {
        case SEND_SUPPLIER_EMAIL: {
            const newState = { ...state };

            if (!newState.sentEmail) {
                newState.sentEmail = {}
            }

            newState.sentEmail[action.payload] = Date.now();
            return newState;
        }
        case LOAD_TASK_BY_ID:
            return Object.assign({}, state, action.payload, { sentEmail: {} });
        case GET_DYNAMIC_FIELDS:
            return Object.assign({}, state, action.payload);
        case GET_PROJECT_LIST:
            return Object.assign({}, state, action.payload);
        case GET_TASK_BY_ID:
            return Object.assign({}, state, action.payload, { sentEmail: {} });
        case GET_PAINT_LIST:
            return Object.assign({}, state, action.payload);
        case GET_HTML_PRE_VIEW:
            return Object.assign({}, state, action.payload);
        case GET_COMMENTS_LIST:
            return Object.assign({}, state, action.payload);
        case GET_SALES_PERSONS_LIST:
            return Object.assign({}, state, action.payload);
        case ADD_COMMENT:
            _addComment(state, action.payload);
            return Object.assign({}, state, action.payload);
        case GET_HISTORY_POSITION:
            return Object.assign({}, state, action.payload);
        case GET_HISTORY_STATUS:
            return Object.assign({}, state, action.payload);
        case GET_HISTORY_CREATED:
            return Object.assign({}, state, action.payload);
        case GET_HISTORY_UPDATE:
            return Object.assign({}, state, action.payload);
        case GET_HISTORY_VIEW:
            return Object.assign({}, state, action.payload);
        case SET_PROJECT_ATTACHMENTS:
            return Object.assign({}, state, action.payload);
        case DELETE_ATTACHMENT:
            // Remove attachment from the state
            for (let i = 0; i < state.currentAttachments.length; i++) {
                if (state.currentAttachments[i].id == action.payload.deleteAttachment) {
                    state.currentAttachments.splice(i, 1);
                }
            }
            return Object.assign({}, state, action.payload);
        case DELETE_TASK_BY_ID:
            return state;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/tasks/index.js